<template>
    <div>
        <public-head title="校园环境"></public-head>
        <div class="main" v-if="scienceData.length>0">
            <div v-for="(item,index) in scienceData" :key="index">
                <img class="img" :src="item" />
            </div>
        </div>
        <div v-else class="_noPost">
            <img
                src="https://new.schoolpi.net/attach/small_program/index/no-data.png"
                class="no-data"
            />
        </div>
    </div>
</template>

<script>
import PublicHead from "../../../../components/publicHead";
import { httpPost } from "../../../../axios/index";
export default {
    data() {
        return {
            scienceData: []
        };
    },
    created() {},
    methods: {
        // 获取专业介绍列表
        fetchAllData(sid) {
            httpPost("/classifie/school_img", {
                sid: sid
            }).then(res => {
              
                if (res.code === 1) {
                    this.scienceData = res.list;
                }
            });
        }
    },
    mounted() {
        this.fetchAllData(this.$route.query.sid);
    },
    components: {
        PublicHead
    }
};
</script>

<style scoped>
/* packageChoose/page//classifie/hostdetail/scienceDetail/scienceDetail.wxss */
.main {
    margin-top: 46px;
}
.img {
    width: 100%;
    /* height: 300px; */
    margin-top: 0.625rem;
}
._noPost {
    text-align: center;
    position: relative;
}
.no-data {
    width: 6.25rem;
    height: 6.25rem;
    position: absolute;
    top: 10.9375rem;
    left: 0;
    right: 0;
    margin: auto;
}
</style>